import React, { useEffect, useState, useRef } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, Tooltip } from 'recharts';
import { getAccountsFromMmr } from "../../api";




type _Tstats = {
    amount: number
    rating: number // if rating is 400 then account rating was 400-600
}[]
const AccountsFromMmr = () => {
    const pDiv = useRef<HTMLDivElement>(null)
    const [stats, setStats] = useState<_Tstats>([])

    useEffect(() => {
        getAccountsFromMmr()
            .then(stats => setStats(stats))
    }, [])

    return (
        <div className="big-block-desktop">
            <div ref={pDiv} style={{ padding: '20px 0 20px 0', textAlign: 'center' }}
                className="major-header">Количество аккаунтов по ммр</div>
            <LineChart
                width={(pDiv.current?.clientWidth) as number - 40}
                height={450}
                data={stats}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis min={0} max={4800} dataKey="rating" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line name="Всего аккаунтов" type="monotone" dataKey="amount" stroke="#8884d8" />
            </LineChart>
        </div>
    )
}

export default AccountsFromMmr
